import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Checkbox, Grid, TextField, Typography } from '@mui/material';
import { updateUserDetails } from '../../../../store/user/duck';
import AladdinHint from '../../../../components/AladdinHint/AladdinHint';

const MyDetailsCustomQuestions = props => {
  const { intl, details, onChangeDetails } = props;

  let { customQuestions, shouldHideProfilePlusCustomQuestions } = details || {};

  if (shouldHideProfilePlusCustomQuestions === undefined) {
    onChangeDetails({ shouldHideProfilePlusCustomQuestions: false });
  }

  if (!customQuestions || customQuestions.length != 2) {
    customQuestions = [
      { question: '', answers: '' },
      { question: '', answers: '' }
    ];
  }

  const onChangeQuestion = (event, index) => {
    let newDetails = [...customQuestions];
    newDetails[index].question = event.target.value;
    onChangeDetails({ customQuestions: newDetails });
  };

  const onChangeAnswers = (event, index) => {
    let newDetails = [...customQuestions];
    newDetails[index].answers = event.target.value;
    onChangeDetails({ customQuestions: newDetails });
  };

  const onChangeShouldHideProfilePlusCustomQuestions = event => {
    onChangeDetails({ shouldHideProfilePlusCustomQuestions: !event.target.checked });
  };

  return (
    <Fragment>
      <Grid container spacing={3} sx={{ flexDirection: 'column' }}>
        <Grid>
          <AladdinHint title={intl.formatMessage({ id: 'custom-questions-hint' })} />
        </Grid>

        <Grid>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Grid>
              <Grid
                container
                sx={{
                  alignItems: 'center'
                }}
              >
                <Grid>
                  <Typography color="primary">{intl.formatMessage({ id: 'show-my-questions' })}</Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid>
              <Checkbox
                id="disableCustomQuestions"
                checked={!shouldHideProfilePlusCustomQuestions}
                onChange={onChangeShouldHideProfilePlusCustomQuestions}
                style={{ padding: 4 }}
              />
            </Grid>
          </Grid>
        </Grid>

        {customQuestions.map((customQuestion, index) => (
          <Grid key={index}>
            <Grid container spacing={3} sx={{ flexDirection: 'column' }}>
              <Grid>
                <TextField
                  label={intl.formatMessage({ id: 'question-number' }, { number: index + 1 })}
                  value={customQuestion.question}
                  onChange={event => onChangeQuestion(event, index)}
                  placeholder={intl.formatMessage({ id: 'custom-question-question-placeholder' })}
                  slotProps={{
                    inputLabel: { shrink: true }
                  }}
                />
              </Grid>

              <Grid>
                <TextField
                  label={
                    <>
                      {intl.formatMessage({ id: 'answers-number' }, { number: index + 1 })}
                      {customQuestion.question?.trim() && <span style={{ color: 'red' }}>*</span>}
                    </>
                  }
                  value={customQuestion.answers}
                  onChange={event => onChangeAnswers(event, index)}
                  placeholder={intl.formatMessage({ id: 'custom-question-answer-placeholder' })}
                  slotProps={{
                    inputLabel: { shrink: true }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

const container = connect(state => ({}), {
  updateUserDetails
})(MyDetailsCustomQuestions);

export default injectIntl(container);
